import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import colorSharp from "../assets/img/Education.gif";
import img from "../assets/img/hero.8f9190d875c91d5c4a5000b756b6f940.svg";
import React from "react";
import HeadButton from "./HeadButton";
import ExperienceCard from "./ExperienceCard";
import TrackVisibility from "react-on-screen";

export const imageStyle = {
  position: "absolute",
  top: "2400px",
  zIndex: "0",
  width: "1572px",
  height: "625px",
  objectFit: "cover",
  color: "transparent",
};

const experiences = [
  {
    title: "Bachelor of Science in Computer Science",
    company: "Mit Shool of Engineering(University of Pune)",
    date: "(Aug 2017 - Aug 2021)",
  },
];

const Education = () => {
  return (
    <section className="education" id="education">
      <Container style={{ padding: "15px" }}>
        <Row className="align-items-center">
          <HeadButton label="Education" labelFontSize="1.5rem" />

          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <img
                    src={colorSharp}
                    alt="Profile Img"
                    style={{
                      borderRadius: "15px",
                      borderImage: "15px",
                      height: "90%",
                      width: "90%",
                    }}
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={7}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "25px" }}
            >
              {experiences.map((experience, index) => (
                <ExperienceCard
                  key={index}
                  title={experience.title}
                  company={experience.company}
                  date={experience.date}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <hr />
      <img
        alt="Hero"
        loading="lazy"
        decoding="async"
        data-nimg="1"
        style={imageStyle}
        src={img}
      />
    </section>
  );
};

export default Education;
